import React from 'react';
import { notification } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

export const successNotification = message => {
  notification.success({
    message,
  });
};

export const infoNotification = message => {
  notification.info({
    message,
  });
};

export const errorNotification = err => {
  if (!err.response) {
    notification.open({
      message: err?.message || 'No response from server!',
      icon: <ExclamationCircleOutlined style={{ color: 'red' }} />,
    });
  } else {
    notification.error({
      message: err.response.data.message || 'No response from server',
      icon: <ExclamationCircleOutlined style={{ color: 'red' }} />,
    });
  }
};

export const errorNotificationOnBlob = async err => {
  if (!err.response) {
    notification.open({
      message: err?.message || 'No response from server!',
      icon: <ExclamationCircleOutlined style={{ color: 'red' }} />,
    });
  } else {
    notification.error({
      message:
        JSON.parse(await err.response.data.text()).message ||
        'No response from server',
      icon: <ExclamationCircleOutlined style={{ color: 'red' }} />,
    });
  }
};
